/**
 * PersonAccessRedirect — `/admin/users/:sub/access` now opens the User
 * Management drilldown on that person (ADR-113 Amendment 3).
 *
 * ⭐⭐ WHY THIS ROUTE STILL EXISTS INSTEAD OF BEING DELETED.
 *
 * D25 says *"one person-centric screen"*. Read literally, it produced a SECOND
 * one — this route, `PersonAccessPage` — while a person-centric screen already
 * existed: the User Management drilldown, which carries memberships, display
 * name, account status, the danger zone and the activity trail. Two screens
 * about one person is the fragmentation D25 exists to end, so the access
 * sections were merged into the drilldown and the standalone page was deleted.
 *
 * The ROUTE is kept because deleting it would break things that are not
 * defects: a deep link to one person's access is worth having, and it is what
 * anyone who bookmarked or shared the old URL will use. A 404 for them would be
 * a regression dressed as a tidy-up.
 *
 * ⚠ IT REDIRECTS TO THE SUBSCRIBERS TAB SPECIFICALLY, and that is not arbitrary.
 * Operator attachments hang off SUBSCRIBER-pool identities — `listAccountsForUser`
 * is keyed on that sub — so the drilldown that owns them is
 * `SubscriberDetailDrawer`. Sending this at the staff tab would open a drawer
 * that structurally cannot hold the rows the URL is asking about.
 *
 * ⚠ `?name=` IS DROPPED ON PURPOSE. The old page used it for its heading; the
 * drilldown reads the person's real name from the server. Forwarding
 * caller-supplied display text into a screen that has the authoritative value
 * would be strictly worse — it is not an identifier and never was.
 */
import { Navigate, useParams } from 'react-router-dom';

export function PersonAccessRedirect() {
  const { sub } = useParams<{ sub: string }>();

  // Only reachable by hand-editing the URL — react-router will not match without
  // the segment. Land on the list rather than an error page: the person cannot be
  // identified, and User Management is where they would be found by name anyway.
  if (!sub) return <Navigate to="/admin/users" replace />;

  return (
    <Navigate
      to={`/admin/users?tab=subscribers&open=${encodeURIComponent(sub)}`}
      replace
    />
  );
}
